import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import ProposalLog from './proposalLog';
import VirtualizedAutoComplete from '../../../../../components/Dropdown/VirtualizedAutocomplete';
import API_BASE_URL from '../../../../../Constants';

import ProposalClasses from './proposalClasses';
import { fetchSalesPersonData, fetchContacts, addProposal, fetchBuildingDevices } from '../hooks/proposalFunctions';
import { fetchBuildings } from '../hooks/useBuildingsDropdown';



const ProposalGenerationWizardForm = () => {
    const [step, setStep] = useState(1);
    const [salesPersonData, setSalesPersonData] = useState([]);
    const [buildingsData, setBuildingsData] = useState([]);
    const [contactsData, setContactsData] = useState([]);
    const [devicesData, setDevicesData] = useState([]);


    const [formData, setFormData] = useState(
        {
            contactName: null,
            title: null,
            phone: null,
            email: null,
            typename: null,
            addContact: false,
            proposalGroup: null,
            description: null,
            priceChange: null,
            taxable: false,
            amountPerDevice: false,
            numberOfInstallments: null,
            numberOfDaysValid: null,
            selectedItems: [],
            documentPath: null,
            documentation: null,
            nextProposalNumber: null,
            proposalClass: null,
            proposalSubclass: null,
            salesId: null,
            salesPersonName: null,
            buildingId: null,
            buildingSite: null,
            city: null,
            state: null,
            zip: null,
            siteAddress: null,
            customerExists: "Yes",
            accountExists: "yes",
            buildingsData: [],
            building: null,
        }
    );



    const handleNext = () => {
        if (validateStep()) {

            setStep(prevStep => prevStep + 1);
        } else {
            alert('Please complete all required fields before proceeding.');
        }
    };

    useEffect(() => {
        fetchBuildings(API_BASE_URL, setBuildingsData);
        fetchContacts(setContactsData);

    }, []);

    const handleBack = () => {
        setStep(prevStep => prevStep - 1);
    };



    const handleContactSelect = (contact) => {
        if (contact) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                contactID: contact.contactID,
                contactName: contact.contactName,
                phone: contact.cellPhone,
                email: contact.emailAddress,
                contact: contact,
            }));
        }
    };


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: type === 'checkbox' ? checked : value,
        }));

        if (name === 'salesId') {
            const selectedSalesPerson = salesPersonData.find(salesPerson => salesPerson.id === value);
            // 

            if (selectedSalesPerson) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    salesId: value,
                    salesPersonName: `${selectedSalesPerson.firstName} ${selectedSalesPerson.lastName}`,
                }));
            }
        }
    };

    const handleItemClick = (item) => {

        const selectedItems = formData.selectedItems;

        const alreadyExists = selectedItems.find(selectedItem => selectedItem.deviceId === item.deviceId);

        if (!alreadyExists) {
            setFormData((prevFormData) => {
                return {
                    ...prevFormData,
                    selectedItems: [...selectedItems, item]
                };
            });
        } else {
            setFormData((prevFormData) => {
                return {
                    ...prevFormData,
                    selectedItems: selectedItems.filter(selectedItem => selectedItem.deviceId !== item.deviceId)
                };
            });
        }
    };

    const handleSubmitProposal = async (e) => {
        e.preventDefault(); // Prevent default form submission
        try {
            const data = await addProposal(API_BASE_URL, formData);
            setFormData({ ...formData, proposalNumber: data.proposalNumber, submitDate: data.submitDate, startDate: data.startDate });
            alert('Proposal saved successfully!');
            handleNext();
        } catch (error) {
            console.error('Error saving proposal:', error);
            alert('Failed to save proposal. Please try again.');
        }
    };

    const handleSalesPersonChange = (e) => {
        const selectedId = e.target.value;

        // Find the salesperson from salesPersonData
        const selectedSalesPerson = salesPersonData.find(person => person.id.toString() === selectedId);

        if (selectedSalesPerson) {
            setFormData({
                ...formData,
                salesPerson: selectedSalesPerson,
                salesId: selectedSalesPerson.id,
                salesPersonName: `${selectedSalesPerson.firstName} ${selectedSalesPerson.lastName}`
            });
        } else {
            // If the entered value doesn't match any ID, reset the name
            setFormData({
                ...formData,
                salesPerson: null,
                salesId: selectedId,
                salesPersonName: ""
            });
        }
    };

    // validate in each step that the data has been updated
    const validateStep = () => {
        switch (step) {
            case 1:
                return formData.accountExists;
            case 2:

                return formData.buildingSite && formData.city && formData.state && formData.zip && formData.salesPersonName;
            case 3:

                // return formData.phone && formData.email && formData.title && formData.typename;
                return true;
            case 4:

                return formData.description && formData.proposalClass && formData.proposalSubclass;
            case 5:


                return formData.priceChange !== null && formData.numberOfInstallments !== null && formData.numberOfDaysValid !== null;
            case 6:
                return true;
            default:
                return true;
        }
    };

    useEffect(() => {
        fetchSalesPersonData(setSalesPersonData);
    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();
        handleNext();
    };




    useEffect(() => {
        if (formData.buildingId) {
            async function fetchData() {
                const devices = await fetchBuildingDevices(formData.buildingId);
                setDevicesData(devices);
            }

            fetchData();
        }
    }, [formData.buildingId]);

    const handleSelect = (building) => {
        if (building) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                building: building,
                buildingId: building.buildingID,
                buildingSite: building.addressLine1,
                city: building.billingCity,
                state: building.billingState,
                zip: building.billingZip,
                siteAddress: building.addressLine1,
            }));
        }
    };

    return (
        // <div className={`p-4 flex justify-center items-center`}>
        <div className="mx-auto pl-4 pr-4 h-screen w-full">
            <form onSubmit={handleSubmit} className={`w-full ${step !== 7 ? 'max-w-lg' : ''}`}>
                {step === 1 && (
                    <div className="border rounded-lg shadow-lg border-black p-4 mb-4">
                        <h2 className="text-xl font-bold mb-2">Proposal Generation Wizard</h2>
                        <p className="mb-4">This wizard will help you create a new proposal. Simply answer the following questions and fill in the information as you go.</p>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Does the Customer exist in your list of Customers? <span className="text-red-500">*</span>
                            <select
                                name="customerExists"
                                value={formData.customerExists}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                required
                            >
                                {/* <option value="">Select</option> */}
                                <option value="yes">Yes</option>
                            </select>
                        </label>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Does the Account exist? <span className="text-red-500">*</span>
                            <select
                                name="accountExists"
                                value={formData.accountExists}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                required
                            >
                                {/* <option value="">Select</option> */}
                                <option value="yes">Yes</option>
                                {/* <option value="no">No</option> */}
                            </select>
                        </label>
                        <button
                            type="button"
                            onClick={handleNext}
                            className="bg-blue-500 text-white p-2 mt-4 w-full hover:bg-blue-600 transition duration-200"
                        >
                            Next
                        </button>
                    </div>
                )}
                {step === 2 && (
                    <div className="border rounded-lg shadow-lg border-black p-4 mb-4">
                        <h2 className="text-xl font-bold mb-2">Choose or Enter the Account / Location</h2>
                        <div className='relative'>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Building Site:
                            </label>
                            <VirtualizedAutoComplete
                                options={buildingsData}
                                value={formData.building}
                                onChange={(e, newValue) => handleSelect(newValue)}
                                label="Select Building Site"
                                optionKey="buildingID"
                                optionLabel="buildingReference"
                            />
                        </div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Site Address:
                            <input readOnly={true} type='text' value={formData.siteAddress} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            City:
                            <input name='city' type='text' value={formData.city} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label>
                        <div className='flex justify-between'>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                State:
                                <input readOnly={true} type='text' name="state" value={formData.state} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                            </label>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                ZIP:
                                <input readOnly={true} type='text' name="zip" value={formData.zip} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                            </label>
                        </div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            SalesPerson:
                            {/* Fetch Salesperson ID and Name from dbo.Salesperson */}
                            <input
                                type="text"
                                name="salesId"
                                value={formData.salesPersonName}
                                onChange={handleSalesPersonChange}
                                list="salesPersonList"
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                            />
                            <datalist id="salesPersonList">
                                {salesPersonData.map((salesPerson) => (
                                    <option key={salesPerson.id} value={salesPerson.id}>
                                        {salesPerson.firstName} {salesPerson.lastName}
                                    </option>
                                ))}
                            </datalist>
                            {formData.salesPersonName && (
                                <p className="text-gray-600 mt-1">Selected: {formData.salesId}</p>
                            )}
                        </label>
                        {/* <label className="block text-gray-700 text-sm font-bold mb-2">
                            Add as active
                            <input
                                type="checkbox"
                                name="isActive"
                                checked={formData.isActive}
                                onChange={handleChange}
                                className="ml-2"
                            />
                        </label> */}
                        {/* <label className="block text-gray-700 text-sm font-bold mb-2">
                            Create new account
                            <input
                                type="checkbox"
                                name="newAccount"
                                checked={formData.newAccount}
                                onChange={handleChange}
                                disabled={formData.accountExists === 'yes'}
                                className="ml-2"
                            />
                        </label> */}
                        <div className="flex justify-between">
                            <button type="button" onClick={handleBack} className="bg-gray-500 rounded text-white p-2 mt-2">Back</button>
                            <button type="button" onClick={handleNext} className="bg-blue-500 rounded text-white p-2 mt-2">Next</button>
                        </div>
                    </div>
                )}
                {step === 3 && (
                    <div className="border rounded-lg shadow-lg border-black p-4 mb-4">
                        <h2 className="text-xl font-bold mb-2">Add or Select a Contact for this Proposal</h2>
                        {/* <label className="block text-gray-700 text-sm font-bold mb-2">
                            Name:
                            <input type="text"
                                name="contactName"
                                value={formData.contactName}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label> */}

                        <VirtualizedAutoComplete
                            options={contactsData}
                            value={contactsData.find((contact) => contact.contactName === formData.contactName) || null}
                            onChange={(e, newValue) => handleContactSelect(newValue)}
                            label="Select Contact"
                            optionKey="contactID"
                            optionLabel="contactName"
                        />
                        {/* <label className="block text-gray-700 text-sm font-bold mb-2">
                            Title:
                            <input type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label> */}
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Phone:
                            <PhoneInput
                                countryCodeEditable={false}
                                disableCountryCode={true}
                                disable
                                country={"us"}
                                value={formData.phone}
                                // onChange={(e) => { handlePhoneChange(e) }}
                                inputClass="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                containerClass="mb-4"
                                inputStyle={{
                                    width: "100%",
                                }}
                                name={"phone"}
                                disableDropdown={false}
                                enableSearch={true}

                               onlyCountries={["us"]}
                            />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Email:
                            <input type="email"
                                name="email"
                                readOnly={true}
                                value={formData.email}
                                // onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Type:
                            {/* TODO: fetch salesperson id from the backend in the dbo.Salesperson table */}
                            <input
                                type="text"
                                name="typename"
                                readOnly={false}
                                value={formData.typename}
                                onChange={handleChange}
                                list="typeList"
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                            />
                            <datalist id="typeList">
                                <option>
                                    Main Contact
                                </option>
                                <option>
                                    Billing Contact
                                </option>
                            </datalist>
                            {/* Will use the lookup function to look for the salesperson and show in the dropdown menu */}
                        </label>
                        {/* <label className="block text-gray-700 text-sm font-bold mb-2">
                            Add contact
                            <input
                                type="checkbox"
                                name="addContact"
                                checked={formData.addContact}
                                onChange={handleChange}
                                className="ml-2"
                            />
                        </label> */}
                        <div className="flex justify-between">
                            <button type="button" onClick={handleBack} className="bg-gray-500 rounded text-white p-2 mt-2">Back</button>
                            <button type="button" onClick={handleNext} className="bg-blue-500 rounded text-white p-2 mt-2">Next</button>
                        </div>
                    </div>
                )}
                {step === 4 && (
                    <div className="border rounded-lg shadow-lg border-black p-4 mb-4">
                        <h2 className="text-xl font-bold mb-2">What type of Proposal is this?</h2>
                        {/* <label className="block text-gray-700 text-sm font-bold mb-2">
                            Use a Proposal Group:
                            <input type="text"
                                name="proposalGroup"
                                value={formData.proposalGroup}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label> */}
                        <ProposalClasses formData={formData} setFormData={setFormData} />
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Enter / Edit the Proposal Description (if necessary):
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label>
                        <div className="flex justify-between">
                            <button type="button" onClick={handleBack} className="bg-gray-500 rounded text-white p-2 mt-2">Back</button>
                            <button type="button" onClick={handleNext} className="bg-blue-500 rounded text-white p-2 mt-2">Next</button>
                        </div>
                    </div>
                )}
                {step === 5 && (
                    <div className="border rounded-lg shadow-lg border-black p-4 mb-4">
                        <h2 className="text-2xl font-bold mb-2">Proposal Amounts and Installments</h2>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Do you know what price you want to change?:
                            <input type="number"
                                name="priceChange"
                                value={formData.priceChange}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Taxable
                            <input
                                type="checkbox"
                                name="taxable"
                                checked={formData.taxable}
                                onChange={handleChange}
                                className="ml-2"
                            />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Amount per device
                            <input
                                type="checkbox"
                                name="amountPerDevice"
                                checked={formData.amountPerDevice}
                                onChange={handleChange}
                                className="ml-2"
                            />
                        </label>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Enter the number of Installments or select an Installments template:
                            <input type="number"
                                name="numberOfInstallments"
                                value={formData.numberOfInstallments}
                                onChange={handleChange}
                                list='numberOfInstallmentsList'
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                            <datalist id="numberOfInstallmentsList">
                                <option>
                                    1
                                </option>
                                <option>
                                    2
                                </option>
                            </datalist>
                        </label>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            No. of Days this proposal is valid:
                            <input type="number"
                                name="numberOfDaysValid"
                                value={formData.numberOfDaysValid}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1" />
                        </label>
                        <div className="flex justify-between">
                            <button type="button" onClick={handleBack} className="bg-gray-500 rounded text-white p-2 mt-2">Back</button>
                            <button type="button" onClick={handleNext} className="bg-blue-500 rounded text-white p-2 mt-2">Next</button>
                        </div>
                    </div>
                )}
                {step === 6 && (
                    <div className="border rounded-lg shadow-lg border-black p-4 mb-4">
                        <h2 className="text-2xl font-bold  mb-2 text-center">
                            Proposal Devices
                        </h2>
                        <div className="mb-4">
                            <ul className="w-full border rounded p-2 mb-2">
                                {devicesData.map((device, index) => (
                                    <li
                                        key={index}
                                        className={`cursor-pointer p-2 ${formData.selectedItems.includes(device) ? 'bg-blue-200' : ''}`}
                                        onClick={() => handleItemClick(device)}
                                    >
                                        {device.deviceId} | {device.deviceStatus} | {device.deviceDomain}
                                    </li>
                                ))}
                            </ul>
                            <div className="flex items-center">
                                <input
                                    name='phasePerDevice'
                                    type="checkbox"
                                    id="phasePerDevice"
                                    value={formData.phasePerDevice}
                                    className="mr-2"
                                    onChange={handleChange}
                                />
                                <label htmlFor="phasePerDevice">Phase per device</label>
                            </div>
                        </div>

                        <div className="flex justify-between">
                            <button
                                type="button"
                                onClick={handleBack}
                                className="bg-gray-500 rounded text-white px-4 py-2"
                            >
                                Back
                            </button>
                            <button
                                type="submit"
                                onClick={handleSubmitProposal}
                                className="bg-blue-500 rounded text-white px-4 py-2"
                            >
                                Create
                            </button>
                        </div>
                    </div>
                )}
                {step >= 7 && (
                    <ProposalLog formData={formData} handleChange={handleChange} setFormData={setFormData} handleSalesPersonChange={handleSalesPersonChange} />
                )}
            </form >
        </div >
    );
};

export default ProposalGenerationWizardForm;